import appInfo from 'js/lib/appInfo';

import epicClient from 'bundles/epic/clients/FrontendInfra';

export const doesAppSupportDarkMode = () => {
  const appName = appInfo.get().appName;
  if (!appName) return false;
  // Whenever updating this list please also update the list in the node-services repo:
  // https://github.com/webedx-spark/node-services/blob/main/packages/services/server-renderer/src/constants.ts
  const APPS_THAT_DO_NOT_SUPPORT_DARK_MODE = epicClient.get('appsThatDoNotSupportDarkMode') ?? [];
  return !APPS_THAT_DO_NOT_SUPPORT_DARK_MODE.includes(appName);
};
